module.exports = __webpack_public_path__ + "static/portrait.078d5aa8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/portrait.jpg
// module id = 303
// module chunks = 263791100135453